import {AfterViewInit, Component} from '@angular/core';
import {RouterLink} from '@angular/router';
import moment from 'moment';

@Component({
  selector: 'app-footer',
  imports: [
    RouterLink
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements AfterViewInit {
  year = moment().year();

  isHydrated = false;

  ngAfterViewInit() {
    setTimeout(() => {
      this.isHydrated = true;
    }, 0);
  }
}
